import {Badge, BadgeProps, styled} from '@mui/material'

const CustomBadge = styled(Badge)<BadgeProps>(({theme}) => ({
  '& .MuiBadge-badge': {
    left: -31,
    right: 'auto',
    backgroundColor: 'white',
  },
}))

export default CustomBadge
